module.exports = __webpack_public_path__ + "img/bold-icon.65f498a2.svg";